import { t } from 'i18next';

export function trimToLength(value: string, maxLength: number): string {
  if (!value) {
    return '';
  }
  const trimmed = value.trim();
  return trimmed.length > maxLength ? `${trimmed.substring(0, maxLength)}...` : trimmed;
}

export function errorToString(error: unknown, maxLength = 240): string {
  let errorMessage = '';

  if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    errorMessage = error;
  } else if (typeof error === 'number') {
    errorMessage = `Error code: ${error}`;
  } else {
    errorMessage = JSON.stringify(error);
  }

  return trimToLength(errorMessage, maxLength);
}

export function mergeAPIError(error: any) {
  if (Array.isArray(error?.errors) && error?.errors.length > 0) {
    const txt = error.errors.map((i: any) => i?.message).join('\n');

    return error?.detail ? `${error?.detail}: - ${txt}` : txt;
  }
  return error?.errors?.[0]?.message || error?.detail || error?.title || error?.error || error?.message;
}

export function getMinikitErrorMessage(error: string) {
  return t(error);
}
